import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, FormGroup, FormControlLabel, Checkbox, Slider, Typography, Box, TextField, Autocomplete } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function FilterAccordion({
  priceRange,
  setPriceRange,
  handleConditionChange,
  handleBookTypeChange,
  handleSchoolChange,
  courseCode,
  setCourseCode,
  options,
  schoolMapping,
  conditions,
  bookTypes,
  selectedSchools
}) {
  return (
    <div className="accordion-container">
      <Accordion disableGutters square sx={{ padding: 0, margin: 0, '&:before': { display: 'none' }, backgroundColor: 'white', boxShadow: 'none' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: '48px', margin: 0 }}>
          <Typography>Condition</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormGroup>
            {['Like New', 'Good', 'Worn'].map((condition) => (
              <FormControlLabel
                key={condition}
                control={
                  <Checkbox 
                    className="styled-checkbox" 
                    checked={conditions.includes(condition)}
                    onChange={(e) => handleConditionChange(condition, e.target.checked)}
                  />
                }
                label={condition}
              />
            ))}
          </FormGroup>
        </AccordionDetails>
      </Accordion>

      <Accordion disableGutters square sx={{ padding: 0, margin: 0, '&:before': { display: 'none' }, backgroundColor: 'white', boxShadow: 'none' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: '48px', margin: 0 }}>
          <Typography>Book Format</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormGroup>
            {['Paperback', 'Hardcover'].map((type) => (
              <FormControlLabel
                key={type}
                control={
                  <Checkbox 
                    className="styled-checkbox" 
                    checked={bookTypes.includes(type)}
                    onChange={(e) => handleBookTypeChange(type, e.target.checked)}
                  />
                }
                label={type}
              />
            ))}
          </FormGroup>
        </AccordionDetails>
      </Accordion>

      <Accordion disableGutters square sx={{ padding: 0, margin: 0, '&:before': { display: 'none' }, backgroundColor: 'white', boxShadow: 'none' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: '48px', margin: 0 }}>
          <Typography>Price Range</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body2" sx={{ fontWeight: 'bold', position: 'absolute', top: '25px', left: '50%' }}>
            ${priceRange[0]} - ${priceRange[1]}
          </Typography>
          <Box sx={{ width: 250, position: 'relative' }}>
            <Slider 
              className="styled-slider" 
              value={priceRange} 
              onChange={(e, newValue) => setPriceRange(newValue)} 
              valueLabelDisplay="auto" 
              min={0} 
              max={250} 
            />
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion disableGutters square sx={{ padding: 0, margin: 0, '&:before': { display: 'none' }, backgroundColor: 'white', boxShadow: 'none' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: '48px', margin: 0 }}>
          <Typography>Course Code</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Autocomplete
            freeSolo
            options={options || []}
            value={courseCode === 'all' ? '' : courseCode}
            onChange={(event, newValue) => setCourseCode(newValue || 'all')}
            onInputChange={(event, newValue) => {
              // Allow partial matches by setting the input value directly
              setCourseCode(newValue || 'all');
            }}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Search Course Code" 
                fullWidth
                placeholder="e.g., CS101"
              />
            )}
            filterOptions={(options, { inputValue }) => {
              // Filter options to show matches that contain the input value
              return options.filter(option => 
                option.toLowerCase().includes(inputValue.toLowerCase())
              );
            }}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion disableGutters square sx={{ padding: 0, margin: 0, '&:before': { display: 'none' }, backgroundColor: 'white', boxShadow: 'none' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: '48px', margin: 0 }}>
          <Typography>School</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormGroup>
            {Object.keys(schoolMapping).map((school) => (
              <FormControlLabel
                key={school}
                control={
                  <Checkbox 
                    className="styled-checkbox" 
                    checked={selectedSchools.includes(school)}
                    onChange={(e) => handleSchoolChange(school, e.target.checked)}
                  />
                }
                label={school}
              />
            ))}
          </FormGroup>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}